<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.statistics_manage')}}<span class="page-header-breadcrumb">></span>{{ $t('words.statistics_viewer_env')}}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.statistics.view_environment_download_tip') }"><i class="icon icon-info-circle-line"></i></span></h3>
                    <div class="page-header-action-group"><a class="btn" :href="getExportUrl"><i class="icon icon-download"></i>{{ $t('words.statistics_download') }}</a></div>
                </div>
                <div class="page-sub-header clearfix">
                    <div class="form-inline float-left">
                        <div class="control-group">
                            <label for="select_channel" class="sr-only">{{ $t('words.channel') }}</label>
                            <select id="select_channel" :placeholder="$t('words.channel')">
                                <!--<option value="">All Channels</option>-->
                                <!--<option :value="channel.id" v-for="channel in select.channels" :key="channel.id">{{ channel.title }}</option>-->
                            </select>
                        </div>
                        <div class="control-group ml-2">
                            <label for="select_live" class="sr-only">{{ $t('words.broadcast') }}</label>
                            <select id="select_live" :placeholder="$t('words.broadcast')">
                                <!--<option value="">All Lives</option>-->
                                <!--<option :value="broadcast.id" v-for="broadcast in select.broadcasts" :key="broadcast.id">{{ broadcast.title }}</option>-->
                            </select>
                        </div>
                        <div class="form-checkbox ml-2">
                            <input type="checkbox" v-model="includeTrashedChannel" id="includeTrashedChannel">
                            <label for="includeTrashedChannel">{{ $t('words.include_removed_channels')}}</label>
                        </div>
                    </div>
                    <div class="module-action-group float-right">
                        <div class="btn-group btn-group__date">
                            <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d')">{{ $t('words.period_today') }}</button>
                            <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d')">{{ $t('words.period_3d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='7d')}" @click="changePeriod('7d')">{{ $t('words.period_7d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='30d')}" @click="changePeriod('30d')">{{ $t('words.period_30d') }}</button>
                        </div>
                        <div class="input-group input-group-date input-daterange" id="date-range">
                            <div class="input-group">
                                <vue-date-picker
                                    v-model="rangeDay"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    range
                                    placeholder="Select date range"
                                    :disabled-date="notRangedDate"
                                >
                                </vue-date-picker>
                            </div>
                            <div class="input-group-append">
                                <button type="button" :class="{'btn': true, 'btn-icon': true, 'active': (period === 'custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-content">
                <div class="btn-group mb-3">
                    <button :class="{btn: true, 'btn-icon': true, 'active': (uriType === 'request')}" @click="changeUriType('request')">{{ $t('words.request_count') }}</button>
                    <button :class="{btn: true, 'btn-icon': true, 'active': (uriType === 'unique_user')}" @click="changeUriType('unique_user')">{{ $t('words.acc_user_count') }}</button>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!--<div class="module module__col">-->
                            <!--<div class="module-header">-->
                                <!--<h5 class="module-title">{{ $t('words.profile') }}</h5>-->
                            <!--</div>-->
                            <!--<div :class="{'module-body':true, 'chart_loading':profileData.loading}" style="height: 300px;">-->
                                <!--<div class="chart__empty__container" v-if="!profileData.loading && (profileData.labels.length === 0)">-->
                                    <!--<div class="chart__empty">-->
                                        <!--<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg><span class="chart__empty__message">{{ $t('paragraphs.list_empty') }}</span>-->
                                    <!--</div>-->
                                <!--</div>-->
                               <!--<pie-chart ref="profileChart" :chartData="profileData" :height="240" :created="profileData.created"></pie-chart>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="module module__col">
                            <div class="module-header">
                                <h5 class="module-title">{{ $t('words.country') }}</h5>
                            </div>
                            <div :class="{'module-body':true, 'chart_loading':countryData.loading}">
                                <div class="chart__empty__container" v-if="!countryData.loading && (countryData.labels.length === 0)">
                                    <div class="chart__empty">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg><span class="chart__empty__message">{{ $t('paragraphs.list_empty') }}</span>
                                    </div>
                                </div>
                                <pie-chart ref="countryChart" :chartData="countryData" :height="284" :created="countryData.created"></pie-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="module module__col">
                            <div class="module-header">
                                <h5 class="module-title">{{ $t('words.domainOrUrl') }}</h5>
                            </div>
                            <div :class="{'module-body':true, 'chart_loading':domainData.loading}">
                                <div class="chart__empty__container" v-if="!domainData.loading && (domainData.labels.length === 0)">
                                    <div class="chart__empty">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg><span class="chart__empty__message">{{ $t('paragraphs.list_empty') }}</span>
                                    </div>
                                </div>
                                <pie-chart ref="domainChart" :chartData="domainData" :height="284" :created="domainData.created"></pie-chart>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="module module__col">
                            <div class="module-header">
                                <h5 class="module-title">{{ $t('words.device') }}</h5>
                            </div>
                            <div :class="{'module-body':true, 'chart_loading':deviceData.loading}">
                                <div class="chart__empty__container" v-if="!deviceData.loading && (deviceData.labels.length === 0)">
                                    <div class="chart__empty">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg><span class="chart__empty__message">{{ $t('paragraphs.list_empty') }}</span>
                                    </div>
                                </div>
                                <pie-chart ref="deviceChart" :chartData="deviceData" :height="284" :created="deviceData.created"></pie-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="module module__col">
                            <div class="module-header">
                                <h5 class="module-title">{{ $t('words.os') }}</h5>
                            </div>
                            <div :class="{'module-body':true, 'chart_loading':osData.loading}">
                                <div class="chart__empty__container" v-if="!osData.loading && (osData.labels.length === 0)">
                                    <div class="chart__empty">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg><span class="chart__empty__message">{{ $t('paragraphs.list_empty') }}</span>
                                    </div>
                                </div>
                                <pie-chart ref="osChart" :chartData="osData" :height="284" :created="osData.created"></pie-chart>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="module module__col">
                            <div class="module-header">
                                <h5 class="module-title">{{ $t('words.browser') }}</h5>
                            </div>
                            <div :class="{'module-body':true, 'chart_loading':browserData.loading}">
                                <div class="chart__empty__container" v-if="!browserData.loading && (browserData.labels.length === 0)">
                                    <div class="chart__empty">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg><span class="chart__empty__message">{{ $t('paragraphs.list_empty') }}</span>
                                    </div>
                                </div>
                                <pie-chart ref="browserChart" :chartData="browserData" :height="284" :created="browserData.created"></pie-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';
import PieChart from './chart/PieChart';
import 'selectize';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        PieChart,
        VueDatePicker,
    },
    data() {
        return {
            uriType: 'request',
            selectedChannel: '',
            selectize_channels: null,
            selectize_broadcasts: null,
            selectedBroadcast: '',
            includeTrashedChannel: false,
            channel: {},
            broadcast: {},
            startDayLimit: '',
            endDayLimit: '',
            rangeDay: [],
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            period: '',
            profileData: {
                loading: true,
                labels: [],
                results: [],
                background: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E'],
                created: null,
            },
            countryData: {
                loading: true,
                labels: [],
                results: [],
                background: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E'],
                created: null,
            },
            browserData: {
                loading: true,
                labels: [],
                results: [],
                background: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E'],
                created: null,
            },
            osData: {
                loading: true,
                labels: [],
                results: [],
                background: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E'],
                created: null,
            },
            domainData: {
                loading: true,
                labels: [],
                results: [],
                background: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E'],
                created: null,
            },
            deviceData: {
                loading: true,
                labels: [],
                results: [],
                background: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E'],
                created: null,
            },
        };
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            // this.loadChannel();
            this.initSelectableDate('1y');
            this.changePeriod('1d');
            this.loadSelectChannel();
            // this.loadBroadcast();
        },
        changeUriType(uriType) {
            this.uriType = uriType;
            this.loadChart();
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';

            this.loadChart();
        },
        loadChart() {
            // this.initProfileChartData();
            // this.getProfileChartData();
            this.initCountryChartData();
            this.getCountryChartData();
            this.initDomainChartData();
            this.getDomainChartData();
            this.initDeviceChartData();
            this.getDeviceChartData();
            this.initOsChartData();
            this.getOsChartData();
            this.initBrowserChartData();
            this.getBrowserChartData();
        },
        loadChannel() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.channelApi).then((response) => {
                this.channel = response.data.data;
            });
        },
        loadBroadcast() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.broadcastApi).then((response) => {
                this.broadcast = response.data.data;
                this.broadcast
                    .map(broadcast => ({ ...broadcast, repeat: null }));
                if (this.broadcast.isOnline) {
                    this.calBroadcastDuration(this.broadcast);
                }
            });
        },
        calBroadcastDuration(broadcast) {
            const broadcastIns = broadcast;
            broadcastIns.repeat = setInterval(() => {
                broadcastIns.interval = this.getDuration(broadcast.started_at);

                if (!broadcastIns.isOnline) {
                    clearInterval(broadcastIns.repeat);
                }
            }, 1000);
        },
        loadSelectChannel() {
            const self = this;
            const selectizeObj = $('#select_channel').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.selectedChannel = value;
                    self.selectedBroadcast = '';
                    self.loadChart();
                    // self.loadRecordFiles(self.recordingFilesApiUri);

                    // 방송 검색되도록 수정.
                    self.selectize_broadcasts.onSearchChange('');
                    // self.selectize_broadcasts.clear();
                    // self.selectize_broadcasts.clearOptions();
                    // self.selectize_broadcasts.disable();
                    // self.selectize_broadcasts.load((query, callback) => {
                    //     if (!value.length) {
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //         return;
                    //     }
                    //     const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    //     axios.get(broadcastUri).then((response) => {
                    //         self.selectize_broadcasts.enable();
                    //         response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                    //         callback(response.data.data);
                    //     }).catch((error) => {
                    //         // self.$toasted.error('Failed to load lives');
                    //         // console.log(error.response.data.errors);
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //     });
                    // });

                    // self.selectize_broadcasts.setValue('', true);
                },
                load(query, callback) {
                    this.clear();
                    this.clearOptions();

                    self.selectedChannel = '';
                    self.selectedBroadcast = '';

                    const uri = `/cms/${self.selectedServiceAccount.key}/select_channels?keyword=${query}&with_trashed=${self.includeTrashedChannel}`;

                    axios.get(uri).then((response) => {
                        response.data.data.unshift({ id: '', title: self.$t('words.all_channels') });
                        callback(response.data.data);
                    }).catch((error) => {
                        self.$toasted.error('Failed to load channels');
                        console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_channels') }]);
                    });
                },
            });

            this.selectize_channels = selectizeObj[0].selectize;
            this.loadSelectBroadcast();
        },
        loadSelectBroadcast() {
            const self = this;
            const selectizeObj = $('#select_live').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.selectedBroadcast = value;
                    // self.loadRecordFiles(self.recordingFilesApiUri);
                    // if (!value.length) return;

                    // self.loadBroadcast();
                    self.loadChart();
                },
                load(query, callback) {
                    this.clearOptions();
                    if (self.selectedChannel.length === 0) {
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                        return;
                    }
                    const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    axios.get(broadcastUri).then((response) => {
                        // self.selectize_broadcasts.enable();
                        response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                        callback(response.data.data);
                    }).catch((error) => {
                        // self.$toasted.error('Failed to load lives');
                        // console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    });
                },
            });

            this.selectize_broadcasts = selectizeObj[0].selectize;
            // this.selectize_broadcasts.clearOptions();
            // this.selectize_broadcasts.disable();
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.loadChart();
        },
        initProfileChartData() {
            this.profileData.loading = true;
            this.profileData.labels = [];
            this.profileData.results = [];
            this.$refs.profileChart.loadChart();
        },
        async getProfileChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/profile${this.queryStringApi()}`;

            await axios.get(apiLoc).then((response) => {
                this.profileData.labels = response.data.labels;
                this.profileData.results = response.data.results;
                if (typeof this.profileData.labels === 'object' && this.profileData.labels.length > 0) {
                    this.$refs.profileChart.loadChart();
                }
                this.profileData.loading = false;
            }).catch((error) => {
                this.profileData.loading = false;
            });
        },
        initCountryChartData() {
            this.countryData.loading = true;
            this.countryData.labels = [];
            this.countryData.results = [];
            this.$refs.countryChart.loadChart();
        },
        async getCountryChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/country${this.queryStringApi()}`;

            await axios.get(apiLoc).then((response) => {
                this.countryData.labels = response.data.labels;
                this.countryData.results = response.data.results;
                if (typeof this.countryData.labels === 'object' && this.countryData.labels.length > 0) {
                    this.$refs.countryChart.loadChart();
                }
                this.countryData.loading = false;
            }).catch((error) => {
                this.countryData.loading = false;
            });
        },
        initOsChartData() {
            this.osData.loading = true;
            this.osData.labels = [];
            this.osData.results = [];
            this.$refs.osChart.loadChart();
        },
        async getOsChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/os${this.queryStringApi()}`;

            await axios.get(apiLoc).then((response) => {
                this.osData.labels = response.data.labels;
                this.osData.results = response.data.results;
                if (typeof this.osData.labels === 'object' && this.osData.labels.length > 0) {
                    this.$refs.osChart.loadChart();
                }
                this.osData.loading = false;
            }).catch((error) => {
                this.osData.loading = false;
            });
        },
        initBrowserChartData() {
            this.browserData.loading = true;
            this.browserData.labels = [];
            this.browserData.results = [];
            this.$refs.browserChart.loadChart();
        },
        async getBrowserChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/browser${this.queryStringApi()}`;

            await axios.get(apiLoc).then((response) => {
                this.browserData.labels = response.data.labels;
                this.browserData.results = response.data.results;
                if (typeof this.browserData.labels === 'object' && this.browserData.labels.length > 0) {
                    this.$refs.browserChart.loadChart();
                }
                this.browserData.loading = false;
            }).catch((error) => {
                this.browserData.loading = false;
            });
        },
        initDomainChartData() {
            this.domainData.loading = true;
            this.domainData.labels = [];
            this.domainData.results = [];
            this.$refs.domainChart.loadChart();
        },
        async getDomainChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/domain${this.queryStringApi()}`;

            await axios.get(apiLoc).then((response) => {
                this.domainData.labels = response.data.labels;
                this.domainData.results = response.data.results;
                if (typeof this.domainData.labels === 'object' && this.domainData.labels.length > 0) {
                    this.$refs.domainChart.loadChart();
                }
                this.domainData.loading = false;
            }).catch((error) => {
                this.domainData.loading = false;
            });
        },
        initDeviceChartData() {
            this.deviceData.loading = true;
            this.deviceData.labels = [];
            this.deviceData.results = [];
            this.$refs.deviceChart.loadChart();
        },
        async getDeviceChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/device${this.queryStringApi()}`;

            await axios.get(apiLoc).then((response) => {
                this.deviceData.labels = response.data.labels;
                this.deviceData.results = response.data.results;
                if (typeof this.deviceData.labels === 'object' && this.deviceData.labels.length > 0) {
                    this.$refs.deviceChart.loadChart();
                }
                this.deviceData.loading = false;
            }).catch((error) => {
                this.deviceData.loading = false;
            });
        },
        queryStringApi() {
            let query = '';

            if (this.selectedChannel !== '') {
                query += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    query += `/${this.selectedBroadcast}`;
                }
            }
            query += `?uri_type=${this.uriType}&started_at=${this.startDate}&ended_at=${this.endDate}`;

            return query;
        },
    },
    computed: {
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        broadcastApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/broadcasts/${this.selectedBroadcast}`;
        },
        getExportUrl() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/export_view_environment`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }
            apiLoc += `?uri_type=${this.uriType}&started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.requestInterval}`;

            return apiLoc;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        includeTrashedChannel(newValue) {
            this.selectize_channels.onSearchChange($('#select_channel').val());
        },
    },
};
</script>
